<template>
  <div>
    <page-header>
      <template #breadcrumbs>
        <router-link to="/organizations">Организации</router-link> &raquo; <span>{{ item.nameFull ? item.nameFull : 'Создание нового органа власти' }}</span>
      </template>
      <h2>Карточка органа власти</h2>
    </page-header>
    <div class="nav-inner page-header">
      <ul class="nav nav-tabs nav-justified align-items-center">
        <li class="nav-item">
          <a
              class="nav-link"
              @click.prevent="setActive('tab1')"
              :class="{ active: isActive('tab1') }"
              href="#tab1"
          >Общая информация</a
          >
        </li>
        <li class="nav-item">
          <a
              class="nav-link"
              @click.prevent="setActive('tab5')"
              :class="{ active: isActive('tab5') }"
              href="#tab5"
          >Карта</a
          >
        </li>
      </ul>
    </div>
    <div class="card" v-if="item">
      <div>
        <div class="tab-content" id="myTabContent" v-disable-all="isReadonly">
          <div
              class="tab-pane fade"
              :class="{ 'active show': isActive('tab1') }"
              id="tab1"
          >
            <div class="row mt-10">
              <div class="col-md-6">
                <div class="form-group required">
                  <component-input
                      label="Полное наименование организации"
                      v-model="item.nameFull"
                      placeholder="Введите наименование организации"/>
                  <div class="invalid-msg" v-if="v$.item.nameFull.$error">
                    <template v-if="v$.item.nameFull.maxLength.$invalid">Максимальная длина поля
                      {{ v$.item.nameFull.maxLength.$params.max }} символов.
                    </template>
                    <template v-else>Введите данные</template>
                  </div>

                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <component-input
                      v-model="item.name"
                      placeholder="Краткое наименование"
                      label="Краткое наименование"
                  />
                  <div class="invalid-msg" v-if="v$.item.name.$error">
                    <template v-if="v$.item.name.maxLength.$invalid">Максимальная длина поля
                      {{ v$.item.name.maxLength.$params.max }} символов.
                    </template>
                    <!-- <template v-else>Введите данные</template> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-10">
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label">Уровень управления</label>
                  <Select2
                      class="select2"
                      :options="districtTypeList"
                      :settings="select2Settings"
                      v-model="item.districtTypeId"
                      v-on:select="changeDistrictType"
                  />
                  <div class="invalid-msg" v-if="v$.item.districtTypeId.$error">Введите данные</div>
                </div>
              </div>
              <div class="col-md-6" v-if="item.districtTypeId > 0">
                <div class="form-group required">
                  <label class="control-label">Муниципальный район (городской округ)</label>
                  <Select2
                      v-if="item.districtTypeId == 2"
                      class="select2"
                      :options="districtList"
                      :settings="select2Settings"
                      v-model="item.districtId"
                  />
                  <div v-else-if="item.districtTypeId == 1">
                    <input class="form-control" value="Нижегородская область" disabled>
                  </div>
                  <div class="invalid-msg" v-if="v$.item.districtId.$error">Введите данные</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label">Вид деятельности</label>
                  <Select2
                      class="select2"
                      :options="kindActivityList"
                      :settings="select2Settings"
                      v-model="item.kindActivityId"
                      style="width: 100%"
                  />
                  <div class="invalid-msg" v-if="v$.item.kindActivityId.$error">Введите данные</div>
                </div>
              </div>
            </div>

           
            <div class="row mt-10">
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label">Фактический адрес</label>
                  <template v-for="(el, key) in item.organizationAddresses"
                            v-bind:key="el.id">
                    <div
                        class="input-group mb-2"
                    >
                      <autocomplete-input v-model="el.address" :id="`addr_fact_${key}`" :url="fiasUrl" placeholder="Введите адрес"/>
                    </div>
                    <div class="invalid-msg" v-if="v$.item.organizationAddresses.$error">Введите данные</div>
                  </template>
                </div>
              </div>
            </div>
            <div class="row mt-10">
            </div>
            <div class="row mt-10">
              <div class="col-md-3">
                <div class="form-group required">
                  <component-input
                      placeholder="ОГРН"
                      label="ОГРН"
                      v-model="item.ogrn"/>
                  <div class="invalid-msg" v-if="v$.item.ogrn.$error">Введите корректные данные</div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group required">
                  <component-input
                      v-model="item.inn"
                      label="ИНН"
                      placeholder="Введите ИНН"/>
                  <div class="invalid-msg" v-if="v$.item.inn.$error">Введите корректные данные</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <component-input label="КПП"
                                   v-model="item.kpp"
                                   placeholder="КПП"/>
                </div>
              </div>
            </div>

          </div>
          <div
              class="tab-pane fade"
              :class="{ 'active show': isActive('tab5') }"
              id="tab5"
          >
            <div class="row">
              <div class="col-md-12">
                <table class="table table-bordered">
                  <thead>
                  <tr>
                    <th class="w-50">Адрес</th>
                    <th class="w-25">Широта</th>
                    <th class="w-25">Долгота</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>

                  <tr v-for="el in item.organizationAddresses" :key="el.id">
                    <td>{{ el.address }}</td>
                    <td>{{ el.lat }}</td>
                    <td>{{ el.lng }}</td>
                    <td>
                      <template v-if="el === mapChooseRow">
                        <button class="btn" v-on:click="mapMarkerSave(el, false)"><i
                            class="fas fa-save" title="Сохранить"></i></button>
                        <button v-if="!isReadonly" class="btn"
                                v-on:click="mapMarkerSave(el, true)"><i
                            class="fas fa-trash-alt" title="Удалить"/></button>
                        <button class="btn" v-on:click="mapMarkerClear"><i class="fas fa-redo"
                                                                           title="Отменить"></i>
                        </button>
                      </template>
                      <template v-else>
                        <button class="btn" v-on:click="mapChooseElement(el)"><i
                            class="fas fa-pen" title="Редактировать"></i></button>
                      </template>
                    </td>
                  </tr>

                  </tbody>
                </table>

              </div>
              <div class="col-md-12">

                <l-map v-if="isActive('tab5')" ref="myMap" style="height:50vh"
                       :zoom="10"
                       :center="mapCurrentCenter"
                       @update:center="mapCenterUpdate">
                  <l-tile-layer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  ></l-tile-layer>
                  <template v-for="el in item.organizationAddresses"
                            :key="el.id">
                    <l-marker v-if="el.lat && el.lng"
                              :lat-lng="el" :icon="getMarkerIcon(false)"
                    >
                      <l-popup :content="el.address"/>
                    </l-marker>
                  </template>

                  <l-marker v-if="mapMarker"
                            :lat-lng="mapMarker" draggable="true" @dragend="mapMarkerDragend"
                            :icon="getMarkerIcon(true)"
                  >
                    <l-popup :content="'(' + mapMarker.lat + ';' + mapMarker.lng + ')'"/>
                  </l-marker>

                </l-map>

              </div>
              
            </div>

          </div>
        </div>
      </div>

      <div class="card-footer">
        <div class="float-right">
          <button type="button" class="btn card-footer__btn--blue mr-2" :class="{ 'disabled': inProcess }"
                  v-on:click="save" v-if="!isReadonly">Сохранить
          </button>
          <button type="button" class="btn card-footer__btn" v-on:click="close">Закрыть</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../../../common/constants";
import API from "../api/organizations";
import "leaflet/dist/leaflet.css"
import {LMap, LMarker, LTileLayer, LPopup} from "@vue-leaflet/vue-leaflet";
import {latLng} from "leaflet";
import { HereProvider } from 'leaflet-geosearch';
import {helpers, maxLength, required} from '@vuelidate/validators'
import {useVuelidate} from '@vuelidate/core'
import PageHeader from "@/common/components/page/PageHeader";
import Utils from "../../../common/utils";
import disableAll from "../../../common/directives/disable-all";
import ComponentInput from "@/common/components/ComponentInput";
import security from "../../../common/mixins/security";
import AutocompleteInput from "../../../common/components/AutocompleteInput";

const selectValidator = (value) => value > 0;
const ogrnValidator = (value) => value === null || value === undefined || value === '' || new RegExp("^[0-9]{13}$", "g").test(value);
const innValidator = (value) => value === null || value === undefined || value === '' || (new RegExp("^[0-9]{10,12}$", "g").test(value) && (value.length == 10 || value.length == 12));
const mapSearchProvider = new HereProvider({
  params: {
    apiKey: Constants.mapSearchApiKey,
    'accept-language': 'ru', // render results in Russia
    countrycodes: 'ru', // limit search results to the Russia
  }
});


function addressValidator(value) {
  return !!(value && value.length && value[0].address);
}

const districtValidator = (param) =>
    helpers.withParams(
        {type: 'districtValidator', value: param},
        (value) => {
            if (param != 2) return true;
            return value > 0;
        }
    );


export default {
  name: "OrganVlastiCard",
  components: {
    AutocompleteInput,
    ComponentInput,
    PageHeader,
    LMap,
    LMarker,
    LTileLayer,
    LPopup
  },
  directives: {
    'disable-all': disableAll
  },
  mixins: [security],
  data() {
    return {
      id: this.$route.params.id,
      isReadonly: this.$route.params.action === "view",
      inProcess: false,
      item: {
        isActive: true,
        name: '',
        nameFull: '',
        isOrgan: true,
        districtTypeId: 0,
        districtId: 0,
        kindActivityId: 0,
        organizationAddresses: [{address: ""}]
      },
      activeItem: "tab1",

      select2Settings: Constants.select2Settings,

      districtList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ],
      kindActivityList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ],

      districtTypeList: [
                {id: 0, text: Constants.emptySelectOptionText, selected: true},
                {id: 1, text: "региональный"},
                {id: 2, text: "муниципальный"},
            ],

      mapMarker: null,
      mapChooseRow: null,
      mapCurrentCenter: latLng(56.30, 44.01),

      OpfPrivate: 3,

      fiasUrl: Constants.fiasApiUrl
    };
  },
  created() {
    this.checkPermissions([Constants.OrganVlastiEdit, Constants.OrganVlastiView], 'Organization', this.id);
    this.loadPage();

    Utils.loadSelectOptions("kindActivity", this.kindActivityList);
    Utils.loadSelectOptions("district", this.districtList);
  },
  methods: {
    getMarkerIcon(isTemp) {
      return Utils.getMarkerIcon(this.item.kindActivityId, isTemp);
    },
    isActive(menuItem) {
      return this.activeItem === menuItem;
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
    },
    loadPage() {
      if (this.id > 0) {
        API.find(this.id).then((response) => {
          this.item = response.data;
          this.item.districtTypeId = this.item.districtId ? 2 : 1;
          if (
              !this.item.organizationAddresses ||
              !this.item.organizationAddresses.length
          ) {
            this.item.organizationAddresses = [{address: ""}];
          }
        });
      }
    },

    save() {
      if (this.inProcess)
        return;

      var self = this;
      this.v$.$touch();
      if (this.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }

      self.inProcess = true;

      const toSave = Object.assign({}, this.item);
      if (toSave.districtId == 0)
        toSave.districtId = null;

      API.save(toSave).then(function (response) {
        self.inProcess = false;
        Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error');
        if (response.data.success && (self.item.id === undefined || self.item.id <= 0)) {
          self.$router.push({name: 'Organizations', params: {isOrgan: true}});
        }
      });
    },
    close() {
      this.$router.push({name: 'Organizations', params: {isOrgan: true}});
    },


    mapChooseElement(el) {
      //если есть координаты отцентровать на ней карту и поставить маркер, если не то на текущую точку
      this.mapChooseRow = el;
      if (el.lat && el.lng) {
        this.mapMarker = latLng(el.lat, el.lng);
        this.mapCurrentCenter = latLng(el.lat, el.lng);
      } else {
        //попытаться найти по адресу
        this.mapMarker = this.mapCurrentCenter;//latLng(56.30, 44.01); //this.$refs.myMap.mapObject.getCenter();
        mapSearchProvider.search({ query: el.address }).then((results) => {
          if(results && results.length > 0) {
            this.mapMarker = latLng(results[0].y, results[0].x);
            this.mapCurrentCenter = this.mapMarker;
          }
        });        
      }
    },
    mapCenterUpdate(center) {
      this.mapCurrentCenter = center;
    },
    mapMarkerDragend(e) {
      this.mapMarker = e.target._latlng;
    },
    mapMarkerSave(el, isDelete) {
      el.lat = null;
      el.lng = null;

      if (!isDelete) {
        var lat = this.mapMarker.lat;
        var lng = this.mapMarker.lng;
        this.$nextTick(function () {
          el.lat = lat;
          el.lng = lng;
        });
      }

      this.mapChooseRow = null;
      this.mapMarker = null;
    },
    mapMarkerClear() {
      this.mapChooseRow = null;
      this.mapMarker = null;
    },

    changeDistrictType() {
      if(this.item.districtTypeId != 2)
        this.item.districtId = 0;
    }

  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {
        name: {maxLength: maxLength(200)},
        nameFull: {required, maxLength: maxLength(200)},
        districtTypeId: {required, selectValidator},
        districtId: {districtValidator : districtValidator(this.item.districtTypeId)},
        kindActivityId: {required, selectValidator},
        organizationAddresses: {addressValidator},
        ogrn: {required, ogrnValidator},
        inn: {required, innValidator},
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "src/modules/organization/views/index";
@import 'src/modules/ras/views/index';

.select2-dropdown {
  position: static !important;
}

.btn-unload {
  border-radius: 24px;
}

.form-control {
  max-width: 100%;
  background: $white;
  border: 1px solid $gray-light1;
  box-sizing: border-box;
  border-radius: 6px;
}
.control-label{
  font-weight: 400 !important;
  color: $gray-dark;
  font-size: 16px;
}
</style>
